import { Formik } from 'formik';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react'
import SmallLoader from '../../../SmallLoader';
import { MdError } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import getPlatformInfo, { notifySuccess } from '../../../../action/customFn';
import axios from "../../../../axios";
import { setLogin } from '../../../../action/loginAction';
import { useNavigate } from 'react-router-dom';

function NewPasswordForm({googleError}) {
  const userIpInfo = useSelector(state => state?.paymentData?.userIpInfo);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <Formik
      initialValues={{ password: '', confirmPassword: '' }}
      validate={values => {
        const errors = {};
        if (!values.password) {
          errors.password = 'Password is required';
        } 
        if (values.password !== values.confirmPassword) {
          errors.confirmPassword = "Passwords don't match"
        }
        return errors;
      }}
      onSubmit={async (values, { setSubmitting, setStatus }) => {
        try {
          const url = "/user/reset-password";
          const postData = {
            email: localStorage.getItem("otp_email"),
            otp: localStorage.getItem("otp_verify"),
            password: values.password,
            confirm_password: values.confirmPassword,
          };
          const res = await axios.post(url, postData);
          const { message } = res.data;
          notifySuccess(message);
          localStorage.removeItem("otp_email");
          localStorage.removeItem("otp_verify");
          navigate("/login/");
          setSubmitting(false)
        } catch (error) {
          console.log(error);
          setStatus({error: true, message: error.response?.data?.message})
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        status,
      }) => (
        <AnimatePresence>

        <motion.form initial={{x:-100, opacity: 0}} animate={{x: 0, opacity: 1}} exit={{x: 100, opacity: 0}} onSubmit={handleSubmit}>
          <AnimatePresence>
            { (status?.error || googleError?.error) && <motion.div initial={{height:0, opacity:0}} animate={{height:"auto", opacity:1}} exit={{height:0, opacity:0}} className="error-holder">
              <div style={{ width: "20px", fontSize: "20px" }}>
                <MdError />
              </div>
              <span>{status?.message || googleError?.msg}</span>
            </motion.div>}
          </AnimatePresence>
          {!status && <div style={{marginTop:"20px"}}></div>}
          <AnimatePresence>
            {
              errors.password && touched.password && (
                <motion.div key={"password_error_msg"} style={{ margin: "0px", marginBottom: "-10px", color: "#d3351a", fontWeight: "600", fontSize: "13px" }} initial={{ opacity: 0, height: 0 }} exit={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} >{errors.password && touched.password && errors.password}</motion.div>
              )
            }
          </AnimatePresence>
          <div style={{ position: "relative" }}>
            <input id="login__password" value={values.password} onChange={handleChange} onBlur={handleBlur} type="password" name="password" placeholder="Enter your password" style={errors.password && touched.password ? { border: "2px solid #d3351a" } : {}} />
            {errors.password && touched.password && <MdError style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "20px", color: "#d3351a" }} />}
          </div>
          <AnimatePresence>
            {
              errors.confirmPassword && touched.confirmPassword && (
                <motion.div key={"confirmPassword_error_msg"} style={{ margin: "0px", marginBottom: "-10px", color: "#d3351a", fontWeight: "600", fontSize: "13px" }} initial={{ opacity: 0, height: 0 }} exit={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} >{errors.confirmPassword && touched.confirmPassword && errors.confirmPassword}</motion.div>
              )
            }
          </AnimatePresence>
          <div style={{ position: "relative" }}>
            <input id="login__confirmPassword" value={values.confirmPassword} onChange={handleChange} onBlur={handleBlur} type="password" name="confirmPassword" placeholder="Confirm your Password" style={errors.confirmPassword && touched.confirmPassword ? { border: "2px solid #d3351a" } : {}} />
            {errors.confirmPassword && touched.confirmPassword && <MdError style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)", fontSize: "20px", color: "#d3351a" }} />}
          </div>
          <button disabled={isSubmitting} className="submit" type="submit" >
            {isSubmitting ? <SmallLoader color={"#ffff"} /> : "Update Password"}
          </button>
        </motion.form>
      </AnimatePresence>
      )}
    </Formik>
  )
}

export default NewPasswordForm
